import { render, staticRenderFns } from "./STableInformationsComp.vue?vue&type=template&id=2dd5dd30&"
import script from "./STableInformationsComp.vue?vue&type=script&lang=js&"
export * from "./STableInformationsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports